/**
 * Shared utilities for MemoizedPantryMarker components across platforms.
 */

export const ZINDEX_TOPMOST = 1000;
export const ZINDEX_FRESHTRAK = 500;
export const ZINDEX_BOTTOMMOST = 0;

/**
 * Calculates the appropriate zIndex for a marker based on its state.
 * @param {boolean} isActive - Whether the marker is currently selected
 * @param {number|null|undefined} pantryId - The pantry ID from the pantry object
 * @param {string|undefined} source - The pantry's data source ('freshtrak' for the overlay)
 * @returns {number} The zIndex value for the marker
 */
export function getMarkerZIndex(isActive, pantryId, source) {
  if (isActive) return ZINDEX_TOPMOST;
  // FreshTrak overlay pins draw above both provider and scraped Plentiful pins
  // so a green pin stays visible where it overlaps an orange or blue one.
  if (source === 'freshtrak') return ZINDEX_FRESHTRAK;
  if (pantryId && pantryId > 0) return ZINDEX_BOTTOMMOST + 1;
  return ZINDEX_BOTTOMMOST;
}

/**
 * Extracts the icon URI from an icon source, handling both object and string formats.
 * @param {Object|string|null} iconSource - The icon source from getIcon()
 * @returns {string|null} The URI string for the icon
 */
export function getIconUri(iconSource) {
  if (!iconSource) return null;
  return iconSource?.uri || iconSource;
}
